import { Skeleton, Stack, Typography } from "@mui/material";
import Highcharts from "highcharts";
import PieChart from "highcharts-react-official";

export interface IPieData {
  name: string;
  value: number;
  color: string;
  valueDisplay: string;
}
export interface IDonutChart {
  data?: { name: string; value: number; color: string; valueDisplay: string }[];
  loading?: boolean;
  legendSx?: {};
  pieWrapSx?: {};
}

const DonutChart = ({
  data,
  legendSx,
  pieWrapSx,
  loading,
}: Readonly<IDonutChart>) => {
  const totalValue = data ? data.reduce((acc, item) => acc + item.value, 0) : 1;

  const options: Highcharts.Options = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        innerSize: "40%",

        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,

          format: "{point.name}: {point.y} ({point.percentage:.1f}%)",
          style: {
            fontSize: "14px", // Font size for labels
            fontFamily: "IRANYekanX, Arial, sans-serif", // Font family
            fontWeight: "bold", // Make it bold
            color: "#333", // Font color
          },
        },
        showInLegend: false,
      },
    },
    tooltip: {
      useHTML: true, // Enable custom HTML for advanced styling
      borderRadius: 12, // Rounded corners
      borderWidth: 2, // Border thickness
      shadow: true, // Enable shadow
      style: {
        color: "#000", // White text
        fontSize: "14px",
        fontFamily: "IRANYekanX, Arial, sans-serif",
      },
      //@ts-ignore
      formatter: function () {
        return `
          <div style="text-align: center; padding: 4px; z-index:100">
            <strong style="font-size: 12px;">${
              // @ts-ignore
              this.point.name
            }</strong><br />
             <span style="color: #03A9F4;">${
               // @ts-ignore
               this.point.percentage.toFixed(0)
             }%</span>
          </div>`;
      },
    },

    series: [
      {
        type: "pie",
        name: "chart one",
        color: "#006600",
        // lineWidth: 1,
        borderRadius: 3,
        borderWidth: 1,
        legendSymbol: "rectangle",

        data: data
          ? data.map((itm) => ({
              y: itm.value,
              name: itm.name,
              color: itm.color,
            }))
          : [],
      },
    ],
  };

  return (
    <Stack
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        ...pieWrapSx,
      }}
    >
      {data && !loading ? (
        <>
          {data.length > 0 ? (
            <Stack width={300} height={300}>
              <PieChart highcharts={Highcharts} options={options} />
            </Stack>
          ) : (
            <Stack width="100%" height={300}>
              <Typography
                width="100%"
                variant="h6Regular"
                textAlign="center"
                color={(thm) => thm.palette.dark[40]}
                sx={{ mt: "40px" }}
              >
                دیتایی جهت نمایش وجود ندارد
              </Typography>
            </Stack>
          )}
        </>
      ) : (
        <Stack position="relative">
          <Skeleton variant="circular" width="300px" height="300px" />
          <Stack
            position="absolute"
            sx={{
              width: "150px",
              borderRadius: "999px",
              height: "150px",
              zIndex: "100",
              bgcolor: "white",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        </Stack>
      )}
      <Stack
        sx={{
          flexDirection: "row",
          gap: "10px",
          flexWrap: "wrap",
          ...legendSx,
        }}
      >
        {data &&
          !loading &&
          data.map(
            (entry) =>
              entry.value > 0 && (
                <Stack
                  key={entry.name}
                  sx={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <div
                    style={{
                      width: "16px",
                      height: "16px",
                      backgroundColor: entry.color,
                      borderRadius: "999px",
                      marginRight: "8px",
                    }}
                  ></div>
                  <Stack direction="row" flexWrap="wrap" gap={"4px"}>
                    <Typography
                      variant="captionMediumBold"
                      // whiteSpace={{ xs: "wrap", lg: "nowrap" }}
                      whiteSpace="nowrap"
                      color={(thm) => thm.palette.dark[40]}
                    >
                      {entry.name}:
                    </Typography>
                    <Typography
                      variant="captionMediumBold"
                      whiteSpace={{ xs: "wrap", lg: "nowrap" }}
                      color={(thm) => thm.palette.accent.main}
                    >
                      {entry.value + entry.valueDisplay} (
                      {((entry.value / totalValue) * 100).toFixed(0)}%)
                    </Typography>
                  </Stack>
                </Stack>
              )
          )}
        {loading &&
          Array(5)
            .fill("")
            .map((i, _) => (
              <Stack
                display={loading ? "flex" : "none"}
                key={i}
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <Skeleton width="16px" height="16px" variant="circular" />
                <Skeleton width="200px" height="16px" variant="rectangular" />
              </Stack>
            ))}
      </Stack>
    </Stack>
  );
};

export default DonutChart;
